export const fetchDefaultImageModel = async () => {
  const res = await fetch('/api/system/settings')
  if (!res.ok) return 'bfl_flux2pro'
  const s = await res.json()
  return s.image_gen_model || 'bfl_flux2pro'
}
